<template>
  <section class="main-container">
    <div v-if="showPopup" class="p-confirm-popup">
      <div class="p-confirm-popup-content">
        <p>{{ popupMessage }}</p>
        <div class="p-confirm-popup-footer">
          <button class="p-button p-confirm-popup-accept" @click="confirmPopup">
            Sim
          </button>
          <button class="p-button p-confirm-popup-reject" @click="cancelPopup">
            Não
          </button>
        </div>
      </div>
    </div>
    <section class="content">
      <section v-show="isFullOPen" class="message">
        <header class="flex justify-between">
          <div class="left">
            <h3 :style="{ color: 'var(--titulo)', opacity: 0.8 }">
              Detalhes da tarefa
            </h3>
          </div>
          <div class="right">
            <AppButton
              v-bind:visibility="true"
              left_icon="fa-regular fa-circle-xmark fa-xl"
              emitType="close"
              @close="closeFull"
              :width="20"
              :height="20"
              :padding="'0px'"
            />
          </div>
        </header>
        <section class="body">
          <h4>{{ taskData.tarefa }}</h4>
          <article>
            <span>
              <div>{{ taskData.observacao ?? "Sem Observacao" }}</div>
              <!-- <pre></pre> -->
            </span>
            <br />
            <div><b>Inicio:</b> {{ taskData.dataInicial ?? "N/A" }}</div>
            <div><b>Prazo:</b> {{ taskData.dataPrazo ?? "N/A" }}</div>
            <div><b>Fim: </b> {{ taskData.dataFinal ?? "N/A" }}</div>
            <!-- <div>
                              <b>Justificativa: </b>O produto atualmente em uso está vencido e não atende mais às normas de segurança.
                              Por favor, confirme sua aprovação até <b>20/10/2024</b>, para que possamos proceder com a aquisição.
                          </div> -->
          </article>

          <div
            class="footer"
            style="position: absolute; bottom: 0; left: 0; gap: 1em"
          >
            <div class="left">
              <button
                @click="
                  visualizarObject(taskData.objeto_nome, taskData.objeto_id)
                "
                class="btn-info"
                style="min-width: 3em; background-color: var(--amarelo)"
              >
                Visualizar
              </button>
            </div>
            <div class="right">
              <button
                @click="aprovar(taskData.objeto_nome, taskData.objeto_id)"
                class="btn-info"
                style="min-width: 3em; background-color: var(--verde)"
                :disabled="
                  taskData.status == 'finalizado' ||
                  !canAproveList.includes(taskData.objeto_nome)
                "
              >
                Aprovar
              </button>
            </div>
            <div class="right">
              <button
                @click="reprovar(taskData.objeto_nome, taskData.objeto_id)"
                class="btn-info"
                style="min-width: 3em; background-color: #ec5353"
                :disabled="
                  taskData.status == 'finalizado' ||
                  !canAproveList.includes(taskData.objeto_nome)
                "
              >
                Reprovar
              </button>
            </div>
            <!-- <button class="btn-info">Ir para a tarefa</button> -->
          </div>
        </section>
      </section>
      <div class="right_content">
        <header>
          <span>
            <Icon icon="tdesign:task" style="color: var(--icon)" />
            <h3 :style="{ color: 'var(--titulo)' }">Tarefas</h3>
          </span>
          <div class="buttons-container">
            <div class="left">
              <button @click="openTaskForm">
                <!-- <Icon icon="streamline:filter" /> -->
                <i
                  class="fa-solid fa-circle-plus fa-xl"
                  style="color: var(--icon)"
                ></i>
                <span :style="{ color: 'var(--label)' }">Criar</span>
                <!-- <Icon icon="streamline:chat-bubble-square-write-solid" /> -->
              </button>
            </div>
            <div class="right">
              <button
                @click="setSortedBy('priority')"
                class="p-1 b-red"
                :style="{
                  backgroundColor:
                    sortBy == 'priority'
                      ? 'var(--obrigatorio)'
                      : 'var(--button)',
                }"
              >
                Prioridade
              </button>
              <button
                @click="setSortedBy('not-finished')"
                class="p-1"
                :style="{
                  backgroundColor:
                    sortBy == 'not-finished'
                      ? 'var(--obrigatorio)'
                      : 'var(--button)',
                }"
              >
                Por aprovar
              </button>
              <!-- <button @click="setSortedBy('not-finished')" class="p-1">Por aprovar</button> -->
              <button
                @click="setSortedBy('finished')"
                class="p-1"
                :style="{
                  backgroundColor:
                    sortBy == 'finished'
                      ? 'var(--obrigatorio)'
                      : 'var(--button)',
                }"
              >
                Feitos
              </button>
              <button
                @click="setSortedBy('last')"
                class="p-1"
                :style="{
                  backgroundColor:
                    sortBy == 'last' ? 'var(--obrigatorio)' : 'var(--button)',
                }"
              >
                Últimos
              </button>
            </div>
          </div>
        </header>
        <ul class="scrollbar-thin scrollbar-tema scrollbar-orange">          
          <li
            class="min-h-[2em]"
            :style="{
              backgroundColor: item.cor,
              // color: 'var(--label)',
              border: '1px solid var(--colunaLista)',
            }"
            stry
            v-for="item in tasks"
            @click="openFull(item)"
          >
            {{ item.tarefa }}
          </li>
        </ul>
      </div>
    </section>
  </section>
  <TaskForm
    v-if="isTaskForm"
    @closeCreateTask="closeTaskForm"
    @returnData="handleReturnData"
  />

  <PdfPreviewDialog
    v-if="show_pdf_preview"
    :pdfUrl="pdfUrl"
    @close="show_pdf_preview = false"
  />
</template>

<script>
import AppButton from "@/components/updated/button.vue";
import TaskForm from "@/components/task/task_form.vue";
import { toast } from "vue3-toastify";
import Dialog from "@/components/dialog/dinamicDialog.vue";
import axios from "axios";
import { id as loggedID } from "@/extraData";
import PdfPreviewDialog from "@/components/dialog/pdfPreviewDialog.vue";
import { ca } from "date-fns/locale";
import { useWebSocket } from "@/composables/useWebSocket";
export default {
  setup() {
    const { connect: wsConnect } = useWebSocket();
    return { wsConnect };
  },
  data() {
    return {
      baseURl: process.env.VUE_APP_URL_BASE,
      //----------------- Para o preview do pdf -----------
      show_pdf_preview: false,
      pdfUrl: `https://carvalhoconta.weebly.com/uploads/6/5/0/1/65015225/fatura.pdf`,
      // pdfUrl: `https://www.caesp.com.br/libwww/colegios/uploads/uploadsMateriais/04032024140619A-Historia-do-Mundo-Para-Quem-Tem-Pressa-by-Emma-Marriott-z-lib.org_.epub_.pdf`,
      // pdfUrl: `${this.$baseURL}/api/v1/tarefa/pdf/${0}/?custom=1`,

      taskInterval: null,
      isFullOPen: false,
      isTaskForm: false,
      dialogStatus: false,
      showPopup: false,
      popupMessage:
        "Esta é uma encomenda sem orçamento, desejas cancelar o negócio?",
      resolvePopup: null,
      sortBy: "priority",
      taskData: {},
      creationData: {},
      tasks: [],
      currentTask: 0,
      canAproveList: ["ferias", "encomenda", "orcamento", "proposta"],
      userDados: JSON.parse(localStorage.getItem("user")) ?? null,
      dialogProps: {
        multi: false,
        entity: ["armazem"],
        sideBar: true,
        queryParams: {
          armazem: "custom=1",
          viatura: "custom=1",
          tpa: "custom=1",
          tputilizador: "custom=1",
        },
        askMessage: "Deseja copiar as permissões deste tipo de utilizador",
        specialQuery: {
          chefe: "utilizador/s/chefe/",
          responsavel: "utilizador/s/responsavel/",
        },
      },
    };
  },
  components: {
    AppButton,
    TaskForm,
    Dialog,
    PdfPreviewDialog,
  },

  methods: {
    // --------------------------------------------------------------------
    // ----------- Para o intervalo de atualização de tarefas -------------
    // --------------------------------------------------------------------
    startInterval() {
      if (this.taskInterval) {
        clearInterval(this.taskInterval);
      }
      this.taskInterval = setInterval(() => {
        this.getTasks();
      }, 8000);
    },

    stopInterval() {
      if (this.taskInterval) {
        clearInterval(this.taskInterval);
        this.taskInterval = null;
      }
    },
    // --------------------------------------------------------------------
    // --------------------------------------------------------------------

    async visualizarObject(identity_name, identity_id) {
      if (identity_name == "encomenda") {
        const encomenda = await axios.get(
          `${this.$baseURL}/api/v1/${identity_name}/${identity_id}/`
        );
        if (encomenda) {
          this.pdfUrl = `${this.baseURl}/api/v1/encomenda/pdf/${encomenda.data.data.id}/`;
          this.show_pdf_preview = true;
        }
      } else if (identity_name == "planeamento") {
        const planeamento = await axios.get(
          `${this.$baseURL}/api/v1/${identity_name}/${identity_id}/`
        );
        if (planeamento) {
          this.pdfUrl = `${this.baseURl}/api/v1/ordemservico/pdf/${planeamento.data.data.servico_id}/`;
          this.show_pdf_preview = true;
        }
      }

      return;

      switch (identity_name) {
        case "encomenda":
          this.$router.push({ name: "negocio", params: { id: identity_id } });
          break;

        case "ferias":
          this.$router.push({
            name: "utilizador",
            params: { id: identity_id },
          });
          break;

        default:
          console.log("Nenhum objecto encontrado");

          break;
      }
    },

    setSortedBy(value) {

      this.sortBy = value;
      this.getTasks();
    },

    async Finalizar() {
      // alert('Finalizar')
      try {
        const res = await axios.put(
          `${this.$baseURL}/api/v1/tarefa/editar/${this.taskData?.id ?? 0}/`,
          { status: "finalizado" }
        );
        toast.success("Finalizado com sucesso!", {
          position: "top-center",
          autoClose: 500,
        });

        this.getTasks();
      } catch (error) {
        console.log(error);
        toast.error("Erro ao finalizar!", {
          position: "top-center",
          autoClose: 1000,
        });
      }
    },

    async reprovar(identity_name, identity_id) {
        let userConfirmed=true;
      const canAprovar = [
        "ferias",
        "encomenda",
        "orcamento",
        "proposta",
      ].includes(identity_name);

      if (!canAprovar) {
        return;
      }
      // let cusStatus = "reprovado";
      // switch (identity_name) {
      //   case "ferias":
      //     cusStatus = "reprovado";
      //     break;

      //   case "encomenda":
      //     cusStatus = "encomenda";
      //     // identity_name = 'negocio'
      //     break;
      //   default:
      //     break;
      // }

      if (identity_name == "encomenda") {
        // apago a encomenda
        const fetchedEncomenda = await axios.get(
          `${this.$baseURL}/api/v1/${identity_name}/${identity_id}/`
        );
        if(fetchedEncomenda) {
            this.fetchedOrcamento= await axios.get(
                `${this.$baseURL}/api/v1/orcamento/negocio/${fetchedEncomenda.data.data.negocio_id}/`
                );
            if(this.fetchedOrcamento) {
                // check if orcamento is empty array or empty object if empty a pop up will show
            if (
              this.fetchedOrcamento.data.data.length == 0 ||
              this.fetchedOrcamento.data.data == {}
            ) {
              userConfirmed = await this.showConfirm(
                "Esta encomenda não tem orçamento, deseja cancelar o negócio?"
              );
                }
            }
        }
        if(!userConfirmed) {
            return;
        }
        try {
          const deleteEncomenda = await axios.delete(
            `${this.$baseURL}/api/v1/${identity_name}/eliminar/${identity_id}/?reprovar=true`
          );
          if (deleteEncomenda.data.data) {
            this.Finalizar();
            this.closeFull();
            toast.success(
              `${identity_name} ${identity_id} Reprovado Com Sucesso!`,
              {
                position: "top-center",
                autoClose: 500,
              }
            );
          } else {
            toast.error("Erro ao reprovar!", {
              position: "top-center",
              autoClose: 1000,
            });
          }
        } catch (error) {
          console.log(error);
          toast.error("Erro ao reprovar!", {
            position: "top-center",
            autoClose: 1000,
          });
        }
        return;
      }

      try {
        const res = await axios.put(
          `${this.$baseURL}/api/v1/${identity_name}/editar/${identity_id}/`,
          { status: cusStatus }
        );
        toast.success("Reprovado com sucesso!", {
          position: "top-center",
          autoClose: 500,
        });

        this.Finalizar();
        this.closeFull();

        // this.getTasks()
      } catch (error) {
        console.log(error);
        toast.error("Erro ao reprovar!", {
          position: "top-center",
          autoClose: 1000,
        });
      }
    },

    async aprovar(identity_name, identity_id) {
      const canAprovar = [
        "ferias",
        "encomenda",
        "orcamento",
        "proposta",
      ].includes(identity_name);

      if (!canAprovar) {
        return;
      }

      //   // alert('Aprovar')
      //   let cusStatus = "aprovado";
      //   switch (identity_name) {
      //     case "encomenda":
      //       cusStatus = "encomenda";
      //       // identity_name = 'negocio'
      //       break;
      //     case "ferias":
      //       cusStatus = "aprovado";
      //       break;

      //     default:
      //       break;
      //   }

      //let negocio_id = 0;

      // Pegar o negocio_id
      // Aprovar - Marcar o negocio como encomenda
      if (identity_name == "encomenda") {
        try {
          const updateEncomenda = await axios.put(
            `${this.$baseURL}/api/v1/${identity_name}/editar/${identity_id}/?aproval=true`,
            { status: "fechado" }
          );
          if (updateEncomenda.data.data) {
            toast.success(
              `${identity_name} ${identity_id} Aprovado Com Sucesso!`,
              {
                position: "top-center",
                autoClose: 500,
              }
            );
            this.Finalizar();
            this.closeFull();
          } else {
            toast.error("Erro ao aprovar!", {
              position: "top-center",
              autoClose: 1000,
            });
          }
        } catch (error) {
          console.log(error);
          toast.error("Erro ao aprovar!", {
            position: "top-center",
            autoClose: 1000,
          });
        }
        // this.getTasks()
      } else {
        try {
          const res = await axios.put(
            `${
              this.$baseURL
            }/api/v1/${identity_name}/editar/${identity_id}/?loggedId=${
              this.userDados?.id ?? 0
            }`,
            { status: cusStatus }
          );
          toast.success("Aprovado com sucesso!", {
            position: "top-center",
            autoClose: 500,
          });

          this.Finalizar();

          // this.getTasks()
        } catch (error) {
          console.log(error);
          toast.error("Erro ao aprovar!", {
            position: "top-center",
            autoClose: 1000,
          });
        }
      }
    },

    openFull(data) {
      if (data?.status == "finalizado") return;
      this.taskData = data;

      
      
      this.isFullOPen = true;
    },

    closeFull() {
      this.isFullOPen = false;
    },

    closeTaskForm() {
      this.isTaskForm = false;
    },

    openTaskForm() {
      this.isTaskForm = true;
    },

    ifAprovar(text) {
      // if("Aprovar"
    },

    handleReturnData(data) {
      if (data) {
        this.registerTask(data);
      } else {
        console.log("Sem data para registrar");
      }

      // this.isTaskForm = false
    },

    // O backend avisa (tarefas_changed) sempre que uma tarefa do schema é
    // criada/alterada/apagada; várias alterações seguidas dão um só pedido.
    agendarGetTasks() {
      clearTimeout(this.refetchTimeout);
      this.refetchTimeout = setTimeout(() => this.getTasks(), 300);
    },

    async getTasks() {
      try {
        const res = await axios.get(
          `${this.$baseURL}/api/v1/tarefa/?loggedId=${
            this.userDados?.id ?? 0
          }&sort=${this.sortBy}`
        );
        this.tasks = res.data.data;
      } catch (error) {
        console.log(error);
      }
    },

    async registerTask(data) {
      try {
        const res = await axios.post(
          `${this.$baseURL}/api/v1/tarefa/registrar/?loggedId=${
            this.userDados?.id ?? 0
          }`,
          data
        );
        this.creationData = res.data.data;
        this.getTasks();

        toast.success("Tarefa criada com sucesso!", {
          position: "top-center",
          autoClose: 500,
        });
      } catch (error) {
        toast.error("Erro ao criar tarefa!", {
          position: "top-center",
          autoClose: 1000,
        });

        console.log(error);
      }
    },

    showConfirm(message) {
      return new Promise((resolve) => {
        this.popupMessage = message;
        this.showPopup = true;
        this.resolvePopup = resolve; // Store the resolve function
      });
    },
    confirmPopup() {
      if (this.resolvePopup) {
        this.resolvePopup(true); // Resolve the promise with true
        this.hidePopup();
      }
    },
    cancelPopup() {
      if (this.resolvePopup) {
        this.resolvePopup(false); // Resolve the promise with false
        this.hidePopup();
      }
    },
    hidePopup() {
      this.showPopup = false;
      // this.popupMessage = '';
      this.resolvePopup = null;
    },
  },

  mounted() {
    this.getTasks();
    // this.startInterval();
    this.wsConnect("/ws/tarefas/", {
      onOpen: () => this.getTasks(), // apanha o que mudou enquanto esteve desligado
      onMessage: (msg) => {
        if (msg.type === "tarefas_changed") this.agendarGetTasks();
      },
    });
  },

  beforeUnmount() {
    clearTimeout(this.refetchTimeout);
  },


 

  beforeRouteLeave(to, from, next) {
    console.log("Route changing - cleaning up interval");
    // this.stopInterval();
    next();
  },

  created() {
    // this.getTasks()
  },
};
</script>

<style scoped>
.main-container {
  padding: 0.3em;
  background-color: #c2c2c2;
  background-color: var(--fundoForm);
  height: fit-content;
  border-radius: 0.5em;
  width: fit-content;
  position: absolute;
  right: 1em;
  top: 3em;
  z-index: 100;
}

.main-container .right_content header {
  padding: 0.5em;
}
.main-container .right_content header > span {
  display: flex;
  align-items: center;
  gap: 0.5em;
  color: var(--amarelo);
}

.main-container .right_content header .buttons-container {
  display: flex;
  justify-content: space-between;
  gap: 1em;
  margin-top: 0.5em;
}

.main-container .right_content header .left button {
  color: #fff;
}

.main-container .right_content header .right button {
  background-color: #7776766f;
  color: #fff;
  border-radius: 0.3em;
  border: none;
  margin-right: 0.5em;
}

.main-container .content {
  position: relative;
  width: fit-content;
  gap: 1em;
  display: flex;
}

@media (max-width: 1117px) {
  .main-container .content {
    /*background-color: red; */
    flex-direction: column;
  }
}

.main-container .content .message {
  /* position: absolute;
          top: -3.9em;
          left: -106%; */
  border-radius: 0.5em;
  width: 30em;
  background-color: #c4c4c4;
  background-color: rgba(169, 169, 169, 0.8);
  background-color: var(--fundoComponente);
  height: 35em;

  display: flex;
  flex-direction: column;
  /*
              justify-content: space-between;
          */
  gap: 1em;
}

.message header {
  display: flex;
  justify-content: space-between;
  padding: 0.5em;
}
/*
          
          */

.main-container .content .message h4 {
  font-size: 1.2em;
  color: var(--titulo);
  font-weight: 700;
  text-align: center;
  padding-bottom: 1em;
}

.message .body {
  text-transform: capitalize;
  padding: 0.5em;
  min-width: 25em;
}
/*
      .message .body pre{
          text-transform: lowercase;
      }
  */
.message .footer {
  display: flex;
  justify-content: flex-end;
  padding: 1em;
}

.main-container .content ul {
  display: flex;
  padding: 0.5em;
  flex-direction: column;
  gap: 0.3em;
  width: 25em;
  height: 30em;
  overflow-y: auto;
  /*
          
         */
}

.main-container .content ul li {
  padding: 0.3em;
  background-color: #5c1d1d;
  background-color: #9a8313;
  background-color: #5c5c5c;
  background-color: #1111117b;
  color: #fff;

  cursor: pointer;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  padding: 0.3em;
  border-radius: 0.3em;
}

.p-confirm-popup {
  display: flex;
  justify-content: center;
  align-items: center;
  /* Align to the top */
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: auto;
  height: auto;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1001;
  padding-top: 2rem;
  /* Add some padding to the top */
  /* margin-top: 8px; */
  background: #626288;
  color: white;
  border: 0 none;
  border-radius: 10px;
  box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2),
    0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12);
  box-sizing: border-box;
}

.p-confirm-popup-content {
  padding: 1rem;
  display: flex;
  flex-direction: column;
  width: 300px;
  text-wrap: wrap;
}

.p-confirm-popup-footer {
  display: flex;
  justify-content: flex-end;
  padding: 0.5rem 1rem;
  gap: 0.5rem;
}

.p-button {
  font-size: 14px;
  padding: 0.5rem 0.75rem;
  border-radius: 8px;
  cursor: pointer;
}

.p-confirm-popup-reject {
  background-color: rgba(255, 0, 0, 0.792);
  color: white;
}

.p-confirm-popup-accept {
  background-color: rgb(255, 155, 5);
  color: white;
}

.scrollbar-tema {
  scrollbar-width: thin;
  scrollbar-color: var(--scroll) transparent;
}
</style>
